/* eslint-disable */

// Simple React Native specific changes
import '../I18n/I18n'
import DeviceInfo from 'react-native-device-info'

export default {
  // font scaling override - RN default is on
  allowTextFontScaling: true
}

import { devConfig } from "./DevAppConfig"
import { liveConfig } from "./LiveAppConfig"
import { stageConfig } from "./StageAppConfig"

const config = liveConfig // devConfig

export const AWSConfig = {
  version: '2012-08-10',
  apiref: 'https://dev-api.kargoe.com',
  AWSKey: 'AKIAI3T4DN4F3ZRWPIDQ',
  AWSSecret: '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',
  AWSRegion: 'us-east-1',
}

const manufacturer = DeviceInfo.getManufacturerSync()
const model = DeviceInfo.getModelSync()
const osName = DeviceInfo.getSystemNameSync()
const osVersion = DeviceInfo.getSystemVersionSync()
const isEmulator = DeviceInfo.isEmulatorSync()

const manufacturerModel = manufacturer == model ? manufacturer : manufacturer + ', ' + model
const clientDevice = manufacturerModel + ', ' + osName + ' ' + osVersion + (isEmulator ? '(emulator)' : '')

export const KargoeConfig = {
  appDetails: Object.assign({}, config.appDetails, {clientDevice}),
  baseUrlAPI: config.BASE_URL_API,
  baseUrlMedia: config.BASE_URL_MEDIA,
  baseUrlAdmin: config.BASE_URL_ADMIN,
  googleMaps: {
    geocodingKey: config.GOOGLE_GEOCODING_KEY,
    apiKey: config.GOOGLE_API_KEY,
    geocodingUrl: `https://maps.googleapis.com/maps/api/geocode/json?key=${config.GOOGLE_GEOCODING_KEY}`,
    placeUrl: `https://maps.googleapis.com/maps/api/place/nearbysearch/json?key=${config.GOOGLE_GEOCODING_KEY}`,
    placeIdsUrl: `https://maps.googleapis.com/maps/api/place/details/json?placeid=ChIJrTLr-GyuEmsRBfy61i59si0&key=${config.GOOGLE_GEOCODING_KEY}`, // unused
  },
  shoppable: {
    active: false,
    apiUrl: config.SHOPPABLE_API_URL,
  },
  oneSignalKey: config.ONE_SIGNAL_KEY,
  inAppPurchases: config.inAppPurchases,
  onScreenIdentifier: config.appDetails.onScreenIdentifier,
  isEmulator,
}
